import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { HashLink as Link } from 'react-router-hash-link';
import Breadcrumbs from '../../../../components/Breadcrumbs';

import warmup5 from '../../../../images/cuemate101/level1/fundamentals/set1/warmup-5.png';

import baseline1 from '../../../../images/cuemate101/level1/fundamentals/set2/baseline-1.png';
import baseline4 from '../../../../images/cuemate101/level1/fundamentals/set2/baseline-4.png';

import bhwarmup1 from '../../../../images/cuemate101/level2/set3/bh-warmup-1.png';
import bhrally1 from '../../../../images/cuemate101/level2/set4/bh-rally-1.png';

import '../AppFeatures.css';

export default function L2S4BHRallyCue() {
  return (
    <Container className="padding-top-25 padding-bottom-100 animated fadeIn">
      <Breadcrumbs />

      <Row className="padding-top-2">
        <Col sm="12">
          <h2>SET 4: BACKHAND RALLY W CUE</h2>
          <h3>Increase Difficulty and use Cues to Guide Stroke Adjustment</h3>
        </Col>
      </Row>

      <Row className="padding-top-25">
        <Col sm="4">
          <ol>
            <li>Press + to start a new Set</li>
            <img
              src={baseline1}
              className="d-block mx-auto img-fluid img-border"
              alt="Outcome Metrics"
            />
          </ol>
        </Col>
      </Row>

      <Row className="padding-top-25">
        <Col sm="6">
          <ol start="2">
            <li>Enter play conditions</li>
            <span className="blue">Technique, W Cue, Tags ON</span>
            <img
              src={bhwarmup1}
              className="d-block mx-auto img-fluid img-border"
              alt="Outcome Metrics"
            />
          </ol>
        </Col>
        <Col sm="6">
          <br />
          <span className="blue">
            Rallying, Intensity Level 2, Middle, Ad Side, Baseline, Cross Court
          </span>
          <img
            src={bhrally1}
            className="d-block mx-auto img-fluid img-border"
            alt="Outcome Metrics"
          />
        </Col>
      </Row>

      <Row className="padding-top-25">
        <Col sm="6">
          <ol start="3">
            <li>Begin Set</li>
            <p className="blue">
              Rally down +-50 balls the middle from the baseline, Ad side
              <br />
              Return using only Backhand Topspin strokes
              <br />
              Adjust intensity to achieve high spin while maintaining clean strokes
              <br />
              Listen for cues to reinforce the stroke formations that result in the most added spin
            </p>
          </ol>
        </Col>
        <Col sm="5">
          <br />
          <img src={baseline4} className="d-block mx-auto img-fluid" alt="Outcome Metrics" />
        </Col>
      </Row>

      <Row className="padding-top-25">
        <Col sm="6">
          <ol start="4">
            <li>Press Pause when finished</li>
            <img
              src={warmup5}
              className="d-block mx-auto img-fluid img-border"
              alt="Outcome Metrics"
            />
          </ol>
        </Col>
      </Row>

      <Row className="padding-top-25">
        <Col sm={12}>
          <Link to="/cuemate101/level2/court-exercise/set-5">
            <h3>
              Next: Set 5 <i className="fa fa-angle-right" />
            </h3>
          </Link>
        </Col>
      </Row>

      <Breadcrumbs />
    </Container>
  );
}
